<template>
  <div class="p-[1.5rem] shadow-[0px_0px_8px_0px_#3A3A3A1F] rounded-[8px]">
    <div class="mb-[1.5rem] flex items-center justify-between">
      <badge>
        {{ total }} kategori
      </badge>
      <b-button
        :variant="total >= config.MAX_TOTAL_CATEGORY ? 'secondary' : 'primary'"
        size="sm"
        class="!font-normal"
        :disabled="total >= config.MAX_TOTAL_CATEGORY"
        @click="createCategory"
      >
        + Tambah Kategori
      </b-button>
    </div>
    <category-table
      ref="categoryTable"
      @data-ready="handleDataReady"
      @count-update="handleCountUpdate"
      @edit="onEditCategory"
      @delete="onDeleteCategory"
    />

    <category-editor-dialog
      ref="categoryDialog"
      :data="categories"
    />

    <category-delete-dialog
      ref="categoryDeleteDialog"
    />
  </div>
</template>

<script>
import Badge from './Badge.vue'
import CategoryTable from './CategoryTable.vue'
import CategoryEditorDialog from './CategoryEditorDialog.vue'
import CategoryDeleteDialog from './CategoryDeleteDialog.vue'
import { MAX_TOTAL_CATEGORY } from './config'

export default {
  name: 'TabCategory',
  components: {
    Badge,
    CategoryTable,
    CategoryEditorDialog,
    CategoryDeleteDialog,
  },
  data() {
    return {
      total: 0,
      categories: [],
    }
  },
  computed: {
    config() {
      return {
        MAX_TOTAL_CATEGORY,
      }
    },
  },
  methods: {
    handleDataReady(data) {
      this.categories = data
    },
    /**
     * Opens the category dialog in 'add' mode to create a new entry.
     */
    createCategory() {
      this.$refs.categoryDialog.show({
        mode: 'add',
        initialValue: '',
        onSubmit: this.saveCategory,
      })
    },
    /**
     * Syncs the total category count emitted by the CategoryTable component.
     * @param {number} count - Total number of categories available.
     */
    handleCountUpdate(count) {
      this.total = count
    },
    /**
     * Opens the category dialog in 'edit' mode with the selected item's data.
     * @param {Object} item - The category record to be modified.
     */
    onEditCategory(item) {
      this.$refs.categoryDialog.show({
        mode: 'edit',
        initialValue: item.name,
        onSubmit: namaKategori => this.editCategory(item.id, namaKategori),
      })
    },
    /**
     * Opens the delete confirmation dialog to remove a category and reassign its articles.
     * @param {Object} item - The category record marked for deletion.
     */
    onDeleteCategory(item) {
      this.$refs.categoryDeleteDialog.show({
        deletedCategory: item,
        onSubmit: selectedCategory => this.deleteCategory(item, selectedCategory),
      })
    },
    /**
     * Persists a new category to the server and refreshes the table upon success.
     * @param {string} namaKategori - The name of the category to create.
     * @returns {Promise} Resolves when the creation and table refresh are complete.
     */
    async saveCategory(namaKategori) {
      return this.$http_new.post('/live-chat/api/v1/categories', {
        name: namaKategori,
      }).then(res => {
        if (this.$refs.categoryTable) {
          this.$refs.categoryTable.refresh()
        }
        return res
      })
    },
    /**
     * Submits updated category data to the server and refreshes the table.
     * @param {number|string} id - The unique identifier of the category.
     * @param {string} namaKategori - The updated category name.
     * @returns {Promise} Resolves when the update and table refresh are complete.
     */
    async editCategory(id, namaKategori) {
      return this.$http_new.put(`/live-chat/api/v1/categories/${id}`, {
        name: namaKategori,
      }).then(res => {
        if (this.$refs.categoryTable) {
          this.$refs.categoryTable.refresh()
        }
        return res
      })
    },
    /**
     * Removes a category and migrates its associated articles to a fallback category.
     * @param {Object} item - The category to delete.
     * @param {Object} selectedCategory - The fallback category receiving the orphaned articles.
     * @returns {Promise} Resolves when the deletion and table refresh are complete.
     */
    async deleteCategory(item, selectedCategory) {
      return this.$http_new.delete(`/live-chat/api/v1/categories/${item.id}`, {
        data: {
          replacement_category_id: selectedCategory.id,
        },
      }).then(res => {
        if (this.$refs.categoryTable) {
          this.$refs.categoryTable.refresh()
        }
        return res
      })
    },
  },
}
</script>
